const $ = window.jQuery;

function init() {
    // move textarea description to match design
    $('.ginput_container_textarea').each(function() {
        if ($(this).next('.gfield_description').length) {
            const nextthing = $(this).next('.gfield_description');
            $(this).append(nextthing);
        }
    });

    // custom styling and dom manipulation for dropdown fields
    let x, i, j, l, ll, selElmnt, a, b, c;

    x = document.getElementsByClassName("ginput_container_select");
    l = x.length;

    for (i = 0; i < l; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.options.length;

        // Check if select-selected div already exists
        if (!x[i].querySelector('.select-selected')) {
            a = document.createElement("DIV");
            a.setAttribute("class", "select-selected");
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            a.setAttribute("tabindex", "0");  // Make it focusable (accessible via Tab)
            a.setAttribute("role", "combobox");
            a.setAttribute("aria-expanded", "false");
            a.setAttribute("aria-haspopup", "listbox");
            x[i].appendChild(a);
        }

        // Check if select-items div already exists
        if (!x[i].querySelector('.select-items')) {
            b = document.createElement("DIV");
            b.setAttribute("class", "select-items select-hide");
            b.setAttribute("role", "listbox");  // Mark it as a list of options

            for (j = 0; j < ll; j++) {
                c = document.createElement("DIV");
                c.setAttribute("role", "option");
                c.innerHTML = selElmnt.options[j].innerHTML;
                c.setAttribute("tabindex", "-1");

                // Add keyboard navigation for each option
                c.addEventListener("keydown", function(e) {
                    e.stopPropagation();
                    const options = Array.from(this.parentNode.querySelectorAll('div'));
                    const currentIndex = options.indexOf(this);
                    
                    switch(e.key) {
                        case "ArrowDown":
                            e.preventDefault();
                            if (currentIndex < options.length - 1) {
                                // Remove class from all options
                                options.forEach(opt => {
                                    opt.classList.remove('same-as-selected');
                                    opt.setAttribute('tabindex', '-1');
                                });
                                // Add class to next option
                                options[currentIndex + 1].classList.add('same-as-selected');
                                options[currentIndex + 1].setAttribute('tabindex', '0');
                                options[currentIndex + 1].focus();
                            }
                            break;
                        case "ArrowUp":
                            e.preventDefault();
                            if (currentIndex > 0) {
                                // Remove class from all options
                                options.forEach(opt => {
                                    opt.classList.remove('same-as-selected');
                                    opt.setAttribute('tabindex', '-1');
                                });
                                // Add class to previous option
                                options[currentIndex - 1].classList.add('same-as-selected');
                                options[currentIndex - 1].setAttribute('tabindex', '0');
                                options[currentIndex - 1].focus();
                            }
                            break;
                        case "Enter":
                            e.preventDefault();
                            this.click();
                            break;
                        case "Escape":
                            e.preventDefault();
                            const selectSelected = this.parentNode.previousSibling;
                            closeAllSelect(selectSelected);
                            selectSelected.focus();
                            break;
                    }
                });

                // Option click event
                c.addEventListener("click", function(e) {
                    var s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                    var h = this.parentNode.previousSibling;
                    for (var k = 0; k < s.options.length; k++) {
                        if (s.options[k].innerHTML == this.innerHTML) {
                            s.selectedIndex = k;
                            h.innerHTML = this.innerHTML;
                            var y = this.parentNode.getElementsByClassName("same-as-selected");
                            for (var m = 0; m < y.length; m++) {
                                y[m].removeAttribute("class");
                            }
                            this.setAttribute("class", "same-as-selected");
                            break;
                        }
                    }
                    h.click();  // Close dropdown on selection

                    // Trigger change event on the original select
                    var event = new Event('change', {
                        'bubbles': true,
                        'cancelable': true
                    });
                    s.dispatchEvent(event);
                });

                b.appendChild(c);
            }
            x[i].appendChild(b);

            // Add click event to select-selected div
            a = x[i].querySelector('.select-selected');
            a.addEventListener("click", function(e) {
                e.stopPropagation();
                closeAllSelect(this);
                this.nextSibling.classList.toggle("select-hide");
                this.classList.toggle("select-arrow-active");
                this.setAttribute("aria-expanded", this.nextSibling.classList.contains("select-hide") ? "false" : "true");

                // Focus on first option when dropdown opens
                const options = this.nextSibling.querySelectorAll('div');
                if (options.length > 0) {
                    options[0].classList.add('same-as-selected');
                }
            });

            // Add keyboard accessibility for "select-selected"
            a.addEventListener("keydown", function(e) {
                const selectItems = this.nextSibling;
                const options = selectItems.querySelectorAll('div');
                
                if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                    e.preventDefault();
                    if (selectItems.classList.contains("select-hide")) {
                        selectItems.classList.remove("select-hide");
                        this.classList.add("select-arrow-active");
                        this.setAttribute("aria-expanded", "true");

                        if (options.length > 0) {
                            // Remove class from all options first
                            options.forEach(opt => {
                                opt.classList.remove('same-as-selected');
                                opt.setAttribute('tabindex', '-1');
                            });
                            
                            // Add class to first option
                            options[0].classList.add('same-as-selected');
                            options[0].setAttribute('tabindex', '0');
                            
                            setTimeout(() => {
                                options[0].focus();
                            }, 0);
                        }
                    }
                } else if (e.key === "Escape") {
                    e.preventDefault();
                    closeAllSelect(this);
                    this.setAttribute("aria-expanded", "false");
                }
            });
        }
    }

    // Close all select boxes except the current one
    function closeAllSelect(elmnt) {
        var x = document.getElementsByClassName("select-items");
        var y = document.getElementsByClassName("select-selected");
        for (let i = 0; i < y.length; i++) {
            if (elmnt != y[i]) {
                y[i].classList.remove("select-arrow-active");
                y[i].setAttribute("aria-expanded", "false");
            }
        }
        for (let i = 0; i < x.length; i++) {
            x[i].classList.add("select-hide");
        }
    }

    // Close dropdown if clicked outside
    document.addEventListener("click", function(e) {
        closeAllSelect(e.target);
    });

    // Mimic the "user hits letter on keyboard, jumps to that section of options"
    document.addEventListener('keydown', function(event) {
        const activeDropdown = document.querySelector('.select-selected.select-arrow-active');
        if (activeDropdown) {
            const options = activeDropdown.nextElementSibling.querySelectorAll('div');
            const key = event.key.toLowerCase();

            // Check if the key is a letter
            if (key >= 'a' && key <= 'z') {
                for (let option of options) {
                    if (option.textContent.toLowerCase().startsWith(key)) {
                        options.forEach(opt => opt.classList.remove('same-as-selected'));
                        option.classList.add('same-as-selected');

                        // Scroll into view if necessary
                        const container = activeDropdown.nextElementSibling;
                        const targetDiv = option;

                        function scrollToTarget(container, target) {
                            const targetRect = target.getBoundingClientRect();
                            const containerRect = container.getBoundingClientRect();
                            const targetPosition = targetRect.top - containerRect.top + container.scrollTop;

                            container.scrollTo({
                                top: targetPosition,
                                behavior: 'smooth'
                            });
                        }

                        scrollToTarget(container, targetDiv);
                        break;
                    }
                }
            }
        }
    });
}

export { init as default };
